import dayjs from "dayjs";

import { MONOLITH_ORIGIN } from "@/monolithIntegration/monolithIntegration.constants";
import useRestMutation from "@/remoteState/useRestMutation";

const useFetchNewStudentAssignments = () => {
  const sevenDaysAgo = dayjs().subtract(7, "days").format("YYYY-MM-DD");
  const resource = `${MONOLITH_ORIGIN}/api/v3/assignment/student/new/?since=${sevenDaysAgo}`;

  return useRestMutation(resource) as [
    Function,
    {
      data: INewStudentAssignment[] | undefined;
      loading?: boolean;
      error?: Error;
    },
  ];
};

export interface INewStudentAssignment {
  assignment_id: number;
  content_id: string;
  title: string;
  created_by?: {
    id: number;
    pk: number;
    unique_id: string;
    user?: {
      id: number;
      pk: number;
      display_name: string;
      first_name: string;
      last_name: string;
      unique_id: string;
    };
  };
}

useFetchNewStudentAssignments.displayName = "useFetchNewStudentAssignments";
export { useFetchNewStudentAssignments };
